import {
  Button,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography
} from '@material-ui/core'
import BackArrowIcon from 'mdi-react/NavigateBeforeIcon'
import NextArrowIcon from 'mdi-react/NavigateNextIcon'
import { FC, useState } from 'react'
import { WithTranslation, withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { closeDialog } from '../../../../actions/dialogs'
import { CloseDialog } from '../../../../actions/types'
import { MuiClasses } from '../../../../types'
import Dialog from '../../../Dialog'
interface NavigateButtonProps {
  classes: MuiClasses
}
interface DispatchProps {
  closeDialogAction: CloseDialog
  fullName?: any
}

const BeforeLoginApartmentSuccessDialog: FC<
  WithTranslation & NavigateButtonProps & DispatchProps
> = ({ t, classes, closeDialogAction, fullName }) => {
  const [pageNumber, setPageNumber] = useState(0)
  return (
    <Dialog
      dialogId={'BeforeLoginApartmentSuccess'}
      noOpenDialogButton
      onlyConfirmCloses
      borderRadius='20px'
      maxWidth='md'
      Content={
        <Grid container justify='center'>
          <Typography variant='h5' align='left' className={classes.modalTitle}>
            {t('beforeLoginApartment.successDialog.title')}{' '}
            <span className={classes.textButton} onClick={() => null}>
              {t('beforeLoginApartment.successDialog.titleTextButton')}
            </span>
          </Typography>
          {pageNumber === 0 && (
            <Grid container>
              <List className={classes.list}>
                <ListItem className={classes.listItem}>
                  <div className={classes.listNumber} />
                  <ListItemText
                    className={classes.listText}
                    primary={t('beforeLoginApartment.successDialog.p0')}
                  />
                </ListItem>
                <div className={classes.line} />
                <ListItem className={classes.listItem}>
                  <div className={classes.listNumber} />
                  <ListItemText
                    className={classes.listText}
                    primary={t('beforeLoginApartment.successDialog.p1')}
                  />
                </ListItem>
                <div className={classes.line} />
                <ListItem className={classes.listItem}>
                  <div className={classes.listNumber} />
                  <ListItemText
                    className={classes.listText}
                    primary={t('beforeLoginApartment.successDialog.p2')}
                  />
                </ListItem>
              </List>
            </Grid>
          )}

          <Grid container justify='center' spacing={2}>
            {pageNumber > 0 && (
              <Grid item sm={6} xs={12}>
                <Button
                  variant='contained'
                  fullWidth
                  className={classes.primaryBtn}
                  onClick={() => {
                    setPageNumber(pageNumber - 1)
                    //closeDialogAction('BeforeLoginApartmentSuccess')
                  }}
                >
                  <BackArrowIcon
                    className={classes.arrowIcon}
                    style={{ left: '10px' }}
                  />
                  {t('general.back')}
                </Button>
              </Grid>
            )}
            <Grid item sm={6} xs={12}>
              <Button
                variant='contained'
                fullWidth
                className={classes.primaryBtn}
                onClick={() => {
                  // setPageNumber(pageNumber + 1)
                  closeDialogAction('BeforeLoginApartmentSuccess')
                }}
              >
                {t('general.ok')}!
                <NextArrowIcon
                  className={classes.arrowIcon}
                  style={{ right: '10px' }}
                />
              </Button>
            </Grid>
          </Grid>
        </Grid>
      }
    />
  )
}
const mapDispatchToProps = (dispatch: Dispatch) => ({
  closeDialogAction: (id: string) => dispatch(closeDialog(id))
})

export default connect(
  null,
  mapDispatchToProps
)(withTranslation()(BeforeLoginApartmentSuccessDialog))
